module.exports = __webpack_public_path__ + "media/images/symbols/cross-27b4ffea1cb3dc3bb007407197bad27b.svg";